/**
 * 用户端  专利检索
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <cusNav></cusNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>客户管理</div>
         </div>
         <!-- 功能按钮栏 -->
         <div style="display: flex; justify-content: flex-end; gap: 10px;margin: 0px 40px;">
            <el-input v-model="formInline.keyword" placeholder="请输入查询关键词" clearable style="width: 200px;"></el-input>
            <el-button style="background-color: #2A91DD;color: #ffffff;margin-left: 10px;" @click="clickSearch()">查询</el-button>
            <el-button style="background-color: #2A91DD;color: #ffffff;" @click="handleEditCustomer()">新增客户</el-button>
         </div>
         <!-- 客户列表数据 -->
         <div style="margin: 20px 40px;">
            <el-table size="small" :data="customerData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="contact" align="center" label="联系人" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="已评估数量" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="对接人" show-overflow-tooltip>
               </el-table-column>
            </el-table>
         </div>
         <div style="margin: 0px 30px;padding-bottom: 30px;">
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </div>
         <!-- 编辑客户 -->
         <div class="edit-customer">
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editCustomerVisible" width="400px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div>
               <el-form :model="customerForm" style="margin-top: 30px;" ref="customerForm" :rules="customerFormRules">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="customer_name"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>客户名称</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.customer_name" placeholder="请填写客户名称" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="contact"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>联系人</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.contact" placeholder="请填写联系人" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="mobile"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>联系方式</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.mobile" placeholder="联系方式" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">邮箱</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.email" placeholder="请填写邮箱" clearable></el-input>
                  </div>
                  <el-button style="width: 100%;margin-top: 20px;" type="primary" @click="commitCustomer()">确认提交</el-button>
               </el-form>
            </el-dialog>
         </div>
      </div>
    </div>
 </template>
 <script>
   import topInfo from '../../components/topInfo'
   import cusNav from '../../components/cusNav'
   import '../../assets/js/directive'
   import { 
      editCustomer,
      getCustomerPageList,
      handlePatentData
   } from '../../api/evalMG'
   import { checkLogin } from '../../utils/util'
   import Pagination from '../../components/Pagination'
   export default {
      data() {
         return {
            title: '',
            searchNav: '',
            loading: false,
            editCustomerVisible: false,
            setHeader:{
               'token': localStorage.getItem('userToken')
            },
            formInline: {
               page: 1,
               ps: 10,
               keyword: '',
            },
            customerForm: {
               id: '',
               uid: '',
               customer_name: '',
               contact: '',
               mobile: '',
               email: ''
            },
            customerData: [],

            customerFormRules: {
               customer_name: [
                  { required: true, message: '请填写客户名称', trigger: 'blur' }
               ],
               contact: [
                  { required: true, message: '请填写联系人', trigger: 'blur' }
               ],
               mobile: [
                  { required: true, message: '请填写联系方式', trigger: 'blur' }
               ]
            },
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }   
        }
      },
       // 注册组件
      components: {
         Pagination,
         topInfo,
         cusNav
      },
      created(){
         this.getCustomerData()
         // 定时执行
         // this.timeHandlePatentData()
      },
      // 监听
      watch: {

      },
      mounted(){

      },
      methods: {
         // 查询客户列表
         getCustomerData(){
            this.loading = true
            getCustomerPageList(this.formInline)
            .then(res=>{
               if(res.code == 200){
                  this.customerData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.loading = false
               }
            })
         },
         // 显示客户信息编辑弹窗
         handleEditCustomer(index,row){
            if(row){
               this.title = '编辑客户'
               this.customerForm.id = row.id
               this.customerForm.customer_name = row.customer_name
               this.customerForm.contact = row.contact
               this.customerForm.mobile = row.mobile
               this.customerForm.email = row.email
            }else{
               this.title = '新增客户'
               this.customerForm.id = ''
               this.customerForm.customer_name = ''
               this.customerForm.contact = ''
               this.customerForm.mobile = ''
               this.customerForm.email = ''
            }
            this.editCustomerVisible = true
         },
         // 提交客户信息
         commitCustomer(){
            let data = this.customerForm
            if(data.customer_name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写客户名称'
               })
               return false
            }
            if(data.mobile.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写联系方式'
               })
               return false
            }
            if(data.contact.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写联系人'
               })
               return false
            }
            let param = {
               customerName: data.customer_name,
               mobile: data.mobile,
               contact: data.contact,
               email: data.email,
               id: data.id
            }
            editCustomer(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editCustomerVisible = false
                  this.getCustomerData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 点击查询
         clickSearch(){
            this.formInline.page = 1
            this.getCustomerData()
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
            this.getCustomerData()
         },
         // 定时处理数据
         timeHandlePatentData(){
            let param = {
              flag: 'swpu20260309'
            }
            this.timer = setInterval(() => {
              // 执行方法
              handlePatentData(param)
              .then(res=>{
               if(res.code == 200){
                  console.log('执行成功:'+res.data)
               }else{
                  console.log(res.msg)
               }
              })
            }, 5000);
        },
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 20px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .edit-customer>>>.el-input--suffix .el-input__inner {
   height: 32px !important;
  }
.edit-customer>>>.el-input__icon{
   height: 32px !important;
   line-height: 32px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/client/customerClient.vue